import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { GetInvoiceApiParameter } from "@insite/client-framework/Services/InvoiceService";
import loadInvoiceByInvoiceNumber from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoiceByInvoiceNumber";
import { getInvoiceState } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import loadOrderByOrderNumber from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, DispatchLoadInvoiceIfNeeded, DispatchSetInvoiceNumber } from "@insite/client-framework/Store/Pages/InvoiceDetails/Handlers/DisplayInvoice";
import { InvoiceModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<{ invoiceNumber: string, customerNumber?: string; }, GetInvoiceApiParameter, InvoiceModel>;


export const DispatchSetInvoiceNumberExtension: HandlerType = props => {
    props.dispatch({
        type: "Pages/InvoiceDetails/SetInvoiceNumber",
        invoiceNumber: props.parameter.invoiceNumber,
    });
};

export const DispatchLoadInvoiceIfNeededExtension: HandlerType = props => {
    const invoiceState = getInvoiceState(props.getState(), props.parameter.invoiceNumber);
    if ((!invoiceState.value && !invoiceState.isLoading) || !invoiceState.value.invoiceLines) {
        props.dispatch(loadInvoiceByInvoiceNumber(props.parameter));
    }
};


replaceInChain(chain, DispatchSetInvoiceNumber, DispatchSetInvoiceNumberExtension);
replaceInChain(chain, DispatchLoadInvoiceIfNeeded, DispatchLoadInvoiceIfNeededExtension);